<template>
  <div class="home">
    <swiper :options="options" v-if="banner.length">
      <swiper-slide v-for="(item,index) in banner" :key="index">
        <div class="swiper-item-box" :style="{backgroundImage:`url(${item.image})`}">
          <template v-if="index == 0">
            <label>专注电磁功能材料与结构设计及制造</label>
            <span>专业 · 诚信 · 卓越 · 创新</span>
          </template>
        </div>
      </swiper-slide>
    </swiper>
    <div class="dot-box">
      <span v-for="(item,index) in banner" :class="{active:index == banner_index}"></span>
    </div>
    <p class="main-title">ABOUT JIACHI</p>
    <p class="sub-title">
      关于佳驰
      <span></span>
    </p>
    <div class="about">
      <div class="top">
        <img src="../assets/img/main-about.png" alt srcset />
        <p>{{about.js}}</p>
      </div>
      <div class="down show-more" @click="to('/About')">
        <img src="../assets/img/show-more.png" alt srcset />
        查看更多
      </div>
    </div>
    <div class="count" :style="{backgroundImage:'url('+actionBg+')'}">
      <div v-for="(item, index) in actions" :key="index">
        <span class="title">{{item.name}}</span>
        <div class="count-box">
          <countTo class="count-text" :start-val="0" :endVal="item.value" :duration="1000"></countTo>
          <span>{{item.ext}}</span>
        </div>
      </div>
    </div>
    <p class="main-title">SERVICE QUALITY</p>
    <p class="sub-title">
      服务能力
      <span></span>
    </p>
    <div class="service-box">
      <router-link
        tag="div"
        :to="{path:'/service',query:{id:item.id}}"
        class="service"
        v-for="(item, index) in services"
        :key="index"
        :style="{backgroundImage:`url(${item.image})`}"
      >
        <div>
          <p class="title">{{item.title}}</p>
          <p class="en-title">{{item.ex_title}}</p>
        </div>
      </router-link>
      <div class="down show-more" @click="to('/service')">
        <img src="../assets/img/show-more.png" alt srcset />
        查看更多
      </div>
    </div>

    <div class="product">
      <p class="main-title">PRODUCT CENTER</p>
      <p class="sub-title">
        产品中心
        <span></span>
      </p>
      <div class="product-wrap">
        <router-link
          tag="div"
          :to="{path:'/product',query:{idx:item.id}}"
          v-for="(item, index) in product"
          :key="index"
        >
          <div class="img-box">
            <img :src="item.image" alt srcset />
          </div>
          <p class="name">
            {{item.name}}
            <span>系列</span>
          </p>
          <p>
            <span class="tag" :class="{two:i==1}" v-for="(key,i) in item.ex_title">{{key}}</span>
          </p>
        </router-link>
      </div>
      <div class="down show-more" @click="to('/product')">
        <img src="../assets/img/show-more.png" alt srcset />
        查看更多
      </div>
    </div>
    <div class="news">
      <p class="main-title">NEWS</p>
      <p class="sub-title">
        最新资讯
        <span></span>
      </p>
      <div class="news-wrap">
        <router-link :to="{path:'/news-detail',query:{id:news.first.id}}" class="first news-list">
          <img :src="news.first.image" alt srcset />
          <div class="down">
            <p class="name">{{news.first.name}}</p>
            <p class="desc">{{news.first.summary}}</p>
          </div>
        </router-link>
        <router-link
          :to="{path:'/news-detail',query:{id:item.id}}"
          class="other news-list"
          v-for="(item,index) in news.list"
          :key="index"
        >
          <img :src="item.image" alt srcset />
          <div class="right">
            <p class="time">{{item.date}}</p>
            <p class="desc">{{item.name}}</p>
          </div>
        </router-link>
      </div>
      <div class="down show-more" @click="to('/news')">
        <img src="../assets/img/show-more.png" alt srcset />
        查看更多
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  getBanner,
  getAction,
  getPt,
  gsjj,
  fw,
  classe,
  article,
} from "../assets/js/api";
export default {
  name: "Home",
  components: {},
  data() {
    let that = this;
    return {
      banner: [],
      banner_index: 0,
      about: {},
      services: [],
      actions: [],
      product: [],
      news: {
        first: {},
        list: [],
      },
      actionBg:'',
      options: {
        on: {
          slideChangeTransitionStart() {
            that.banner_index = this.realIndex;
          },
        },
        autoplay: {
          delay: 3000,
        },
      },
    };
  },
  created() {
    getBanner().then((r) => {
      this.banner = r.data.data;
    });
    gsjj().then((r) => {
      this.about = {
        ...r.data,
      };
    });
    getPt().then((r) => {
      this.actionBg = r.data.data[0].image;
    });
    getAction().then((r) => {
      r.data.data.forEach((val) => {
        val.value = Number(val.value);
      });
      this.actions = r.data.data;
    });
    fw().then((r) => {
      this.services = r.data.data;
    });
    classe({
      limit: 7,
    }).then((r) => {
      // r.data.data.push({})

      r.data.data.forEach((val) => {
        if (val.ex_title) {
          val.ex_title = val.ex_title.split("/");
        }
      });

      this.product = r.data.data;
    });
    article({
      limit: 5,
      page: 1,
      where: {
        type: 1,
      },
    }).then((r) => {
      r.data.data.forEach(val=>{
        let dt = new Date(val.create_time)
        let [year,month,day] = [dt.getFullYear(),dt.getMonth()+1,dt.getDate()]
        val.create_time  = [year,month,day].join('-')
      })
      this.news.first = r.data.data[0] || {};
      this.news.list = r.data.data.slice(1, 5);
    });
  },
  methods: {
    to(e) {
      this.$router.push({
        path: e,
      });
    },
    change(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="less" scoped>
.swiper-item-box {
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 3.19rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  label {
    font-size: 0.38rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    margin-bottom: 0.33rem;
    color: white;
  }

  span {
    display: inline-block;
    border: 1px solid white;
    font-size: 0.24rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    padding: 0.1rem 0.22rem;
  }
}

.dot-box {
  width: 100%;
  padding: 0.21rem 0;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 0.63rem;

  span {
    display: inline-block;
    width: 0.21rem;
    height: 6px;
    background: rgba(0, 0, 0, 0.4);
    transition: all 0.3s linear;
  }

  span:not(:last-child) {
    margin-right: 9px;
  }

  span.active {
    background: #1d2088;
  }
}

.main-title {
  font-size: 0.3rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #343434;
  text-align: center;
}

.sub-title {
  font-size: 0.36rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #666666;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0.16rem;
  margin-bottom: 0.26rem;

  span {
    display: inline-block;
    width: 0.26rem;
    height: 5px;
    background: #9a9a9a;
    margin-top: 6px;
  }
}

.about {
  .top {
    padding: 0 1.1rem;
    box-sizing: border-box;

    img {
      width: 100%;
    }

    p {
      margin-top: 0.37rem;
      font-size: 0.26rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #444444;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      line-height: 0.4rem;
    }
  }

  .down {
    justify-content: flex-end;
    margin-top: 0.16rem;
  }
}

.count {
  width: 100%;
  height: 7.04rem;
  padding: 0.48rem 0.9rem;
  box-sizing: border-box;
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  background-image: url("../assets/img/count-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: space-between;
  margin-bottom: 0.96rem;

  & > div {
    display: flex;
    width: 2.7rem;
    height: 2.7rem;
    background: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #0858a6;
    padding-top: 0.53rem;
    padding-bottom: 0.67rem;
    box-sizing: border-box;

    .title {
      font-size: 0.24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }

    .count-box {
      font-size: 0.24rem;
      font-weight: 400;
      width: 0.74rem;
      white-space: nowrap;
      padding-bottom: 0.34rem;
      border-bottom: 1px solid #0a66c0;
      text-align: center;
      text-indent: -1em;

      .count-text {
        font-size: 0.38rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
      }
    }
  }
}

.show-more:active {
  opacity: 0.78;
}

.show-more {
  display: flex;
  align-items: center;
  font-size: 0.2rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #9a9a9a;
  padding-right: 0.28rem;
  box-sizing: border-box;
  margin-bottom: 0.65rem;
  justify-content: center;
  width: 100%;

  img {
    width: 0.5rem;
    margin-right: 0.13rem;
  }
}

.service-box {
  display: flex;
  margin-top: 0.62rem;
  flex-wrap: wrap;
  padding: 0 0.3rem;
  box-sizing: border-box;
  padding-bottom: 0.41rem;

  div:nth-child(4) {
    width: 66.66%;
  }

  .show-more {
    margin-top: 0.41rem;
  }

  .service {
    width: 33.33%;
    height: 1.88rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    box-sizing: border-box;
    background-size: cover;
    background-repeat: no-repeat;
    & > div {
      padding: 9px 0.17rem;
      box-sizing: border-box;
      width: 100px;
      background: linear-gradient(to bottom;transparent, black);
    }
    .title {
      font-size: 0.26rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 0.06rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .en-title {
      font-size: 0.18rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.product {
  padding: 0.31rem 0.5rem;
  box-sizing: border-box;
  background-size: cover;
  background-image: url("../assets/img/main-product-bg.png");
  background-repeat: no-repeat;
  background-color: rgb(246, 246, 246);
  margin-bottom: 1rem;

  .product-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    & > div:last-child {
      width: 100%;
    }

    & > div {
      width: 48%;
      height: 3.6rem;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.21);
      padding: 0.12rem;
      box-sizing: border-box;
      margin-bottom: 0.3rem;

      .img-box {
        width: 100%;
        height: 2.25rem;
        background: #eaeef4;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 1.91rem;
          height: 1.48rem;
        }
      }

      p {
        text-align: center;
        font-size: 0;
      }

      .name {
        font-size: 0.23rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin: 0.21rem 0;

        span {
          font-weight: 400;
          margin-left: 0.1rem;
        }
      }

      .tag {
        display: inline-block;
        height: 0.34rem;
        padding: 0 0.29rem;
        font-size: 0.16rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        background: #1270cc;
        border-radius: 0.15rem;
        text-align: center;
        line-height: 0.34rem;
      }

      .tag.two {
        background: #f7b80e;
        margin-left: 0.33rem;
      }
    }
  }

  .show-more {
    margin-bottom: 0;
  }
}

.news {
  padding: 0 0.3rem;
  box-sizing: border-box;

  .news-list {
    margin-bottom: 0.35rem;
  }

  .first {
    img {
      width: 100%;
      height: 3.7rem;
      object-fit: cover;
      vertical-align: middle;
    }

    .down {
      width: 100%;
      padding: 0.28rem 0.41rem;
      box-sizing: border-box;

      box-shadow: 1px 3px 7px 0px rgba(0, 0, 0, 0.07);

      .name {
        font-size: 0.26rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 0.23rem;
      }

      .desc {
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        line-height: 0.3rem;
      }
    }
  }

  .other {
    background: #dedede;
    padding: 0.29rem;
    box-sizing: border-box;
    display: flex;

    img {
      width: 2.31rem;
      height: 100%;
    }

    .right {
      padding: 0 0.28rem;
      box-sizing: border-box;
      width: calc(100% - 2.31rem);

      .time {
        margin-bottom: 0.28rem;
        font-size: 0.35rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .desc {
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 0.3rem;
      }
    }
  }
}
</style>
